/**
 * @prettier
 */
import { Input } from 'theme-ui';

export const LastName = Input;
